import MetaTags from "react-meta-tags";
import React from "react";
import { Row, Col, Alert, Container } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { userForgetPassword } from "../../slices/thunks";

//import images
import logolight from "../../assets/images/logo-light.png";
import logoDark from "../../assets/images/logo-dark.png";

interface ForgetPasswordProps {
  history: object;
}

const ForgetPasswordPage = ({ history }: ForgetPasswordProps) => {
  const dispatch = useDispatch();

  const { forgetError, forgetSuccessMsg } = useSelector((state: any) => ({
    forgetError: state.forgetPassword.forgetError,
    forgetSuccessMsg: state.forgetPassword.forgetSuccessMsg,
  }));

  function handleValidSubmit(event: any, values: any) {
    dispatch(userForgetPassword(values.email, history));
  }
  return (
    <React.Fragment>
      <MetaTags>
        <title>
          Recuperar contraseña
        </title>
      </MetaTags>
      <div className="authentication-bg min-vh-100">
        <div className="bg-overlay bg-white"></div>
        <Container>
          <div className="d-flex flex-column min-vh-100 px-3 pt-4">
            <Row className="justify-content-center my-auto">
              <Col md={8} lg={6} xl={4}>
                <div className="py-5">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="40" className="auth-logo-dark" />
                      <img src={logolight} alt="" height="40" className="auth-logo-light" />
                    </Link>
                  </div>
                  <div className="text-center mb-4">
                    <h5>Olvidaste tu contraseña?</h5>
                  </div>

                  {forgetError && forgetError ? (
                    <Alert color="danger" style={{ marginTop: "13px" }}>
                      {forgetError}
                    </Alert>
                  ) : null}
                  {forgetSuccessMsg ? (
                    <Alert color="success" style={{ marginTop: "13px" }}>
                      {forgetSuccessMsg}
                    </Alert>
                  ) : null}

                  <AvForm
                    className="custom-form mt-4"
                    onValidSubmit={(e: any, v: any) =>
                      handleValidSubmit(e, v)
                    }
                  >
                    <div className="form-floating form-floating-custom mb-3 light">
                      <AvField
                        name="email"
                        label="Email"
                        className="form-control"
                        placeholder="Ingresar mail"
                        errorMessage="Debe ingresar el mail de su cuenta"
                        type="email"
                        required
                      />
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-info w-100"
                        type="submit"
                      >
                        Enviar
                      </button>
                    </div>
                  </AvForm>

                  <div className="mt-5 text-center text-muted">
                    <Link to="login" className="fw-medium text-decoration-underline"> Volver al inicio de sesión </Link>
                  </div>

                </div>
              </Col>
            </Row>
          </div>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ForgetPasswordPage);